module.exports = "<h1>Please wait</h1>";


//////////////////
// WEBPACK FOOTER
// ./app/views/azure-login/app/template/azure-login.html
// module id = 423
// module chunks = 0